/*       */

import { gql } from '@apollo/client';

export default gql`
    query locationGetAddressQuery($latitude: Float!, $longitude: Float!) {
        result: getAddress(latitude: $latitude, longitude: $longitude)
    }
`;
